export const reverseMap = <TKey extends string, TItem extends string>(
  item: TItem,
  map: {[key in TKey]: TItem},
): TKey | undefined => {
  const key = Object.keys(map).find(key => map[key as TKey] === item) as TKey;

  return key;
};
